module.exports = __webpack_public_path__ + "img/img15.81d55712.jpg";